import { ObtenerSucursales, Cargando, Error } from "../Types/Sucursal.type";
import { firebaseFS } from "../Firebase/FirebaseApp";
import { dispatchController } from "./index.actions";
import { __Colecciones } from "./../environment";

export const obtenerSucursales = () => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    let sucursales = [];
    const respuesta = await firebaseFS.collection(__Colecciones.Sucursal);
    await respuesta.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        sucursales = [
          ...sucursales,
          {
            id: doc.id,
            datos: doc.data(),
          },
        ];
      });
    });

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: sucursales,
    };

    dispatchController(ObtenerSucursales, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};
